'use es6';

import { connect } from 'react-redux';
import { getSrc, getAltText, getAlignment, getWidth, getHeight, getAspectRatio, getIsMaxWidth } from 'FormsUI/selectors/selectedRichTextImage';
import { updateImageFile, updateSrc, updateAlt, updateAlignment, updateWidth, updateHeight, updateSrcAndAltText, updateAspectRatio, toggleImageMaxWidth } from 'FormsUI/actions/updateRichTextImage';
import ImageConfigurationPanel from './ImageConfigurationPanel';
const mapDispatchToProps = {
  updateImageFile,
  updateSrcAndAltText,
  updateAltText: updateAlt,
  updateSrc,
  updateAlignment,
  updateWidth,
  updateHeight,
  updateAspectRatio,
  toggleImageMaxWidth
};
const mapStateToProps = (state, props) => Object.assign({
  altText: getAltText(state),
  imageSrc: getSrc(state),
  alignment: getAlignment(state),
  width: getWidth(state),
  height: getHeight(state),
  aspectRatio: getAspectRatio(state),
  isMaxWidth: getIsMaxWidth(state)
}, props);
export default connect(mapStateToProps, mapDispatchToProps)(ImageConfigurationPanel);